export enum SiteMap {
  HOME = '/',
  NEWHOME = '/new-home',
  BRANDS = '/corners',
  EVENTS = '/events',
  FOOD = '/food',
  SERVICES = '/services',
  FIRST_SERVICE = '/services/parkovka-4623a1f5c2',
  CERTIFICATES = '/cards',
  STORIES = '/news',
  CONTACTS = '/contacts',
  MAP = '/map',
  INFO = '/info',
  PRIVACY_POLICY = '/info/privacy-policy',
  GIFT_CARD_RULES = '/info/gift-card-rules',
  FAQ = '/info/faq',
  INFO_PROGRAM_TERMS = '/info/program-terms',
  PAYMENT = '/info/payment',
  LOYALITY_OVERVIEW = '/loyality',
  ABOUT = '/about',
  LOGIN = '/login',
  SIGN_UP = '/signup',
  ACCOUNT = '/lk',
  LOYALITY = '/lk/loyality',
  PERSONAL_INFO = '/lk/personal-info',
  PERSONAL_ACCOUNT = '/lk/personal-account',
  LK_PROGRAM_TERMS = '/lk/program-terms',
  FEEDBACK = '/lk/feedback',
  SUBSCRIPTIONS = '/lk/subscriptions',
  LOYALITY_BRANDS = '/lk/discounts',
  MY_EVENTS = '/lk/events',
  ACCOUNT_ORDERS = '/lk/orders',
  SEARCH = '/search',
  UNSORTED = '/unsorted',
  NOT_AVAILABLE = '/not-available',
  STUB_AUTH = '/stub-auth',
  CARDS_ELECTRONIC = '/cards/electronic',
  CARDS_PLASTIC = '/cards/plastic',
  ORDER_CARD_ELECTRONIC = '/cards/electronic/order',
  ORDER_CARD_PLASTIC = '/cards/plastic/order',
  GIFT = '/gift',
  FLOORS = '/floors',
}

export enum UrlQueryParam {
  SEARCH_QUERY = 'q',
  REDIRECT_URL = 'redirect_url',
}

export const FLOORS = Object.freeze([-1, 1, 2, 3, 4, 5, 6, 7]);

export enum LocalStorageItem {
  ATTEMPT_AUTH = 'attemptAuth',
  SEARCH_SUGGESTIONS = 'searchSuggestions',
  TOKEN = 'token',
  IS_REGISTERED = 'isRegistered',
  PHONE = 'phone',
  LANGUAGE = 'lang',
  DEVICE_ID = 'deviceId',
  BADGE_FIXED = 'bFixed',
  BADGE_VISIBLE = 'bVisisble',
}
